import staticPageService from '@/services/staticPageService';

export default {
  namespaced: true,
  
  state: {
    pages: [],
    currentPage: null,
    loading: false,
    error: null
  },
  
  getters: {
    allPages: state => state.pages,
    currentPage: state => state.currentPage,
    isLoading: state => state.loading,
    hasError: state => state.error !== null,
    errorMessage: state => state.error
  },
  
  mutations: {
    SET_PAGES(state, pages) {
      state.pages = pages;
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    CLEAR_ERROR(state) {
      state.error = null;
    }
  },
  
  actions: {
    async fetchPages({ commit }) {
      try {
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');
        
        const response = await staticPageService.getAllStaticPages();
        commit('SET_PAGES', response.data.results || response.data);
      } catch (error) {
        console.error('Error fetching static pages:', error);
        commit('SET_ERROR', error.message || 'Failed to fetch static pages');
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async fetchPageBySlug({ commit }, slug) {
      try {
        commit('SET_LOADING', true);
        commit('CLEAR_ERROR');
        
        const response = await staticPageService.getStaticPage(slug);
        commit('SET_CURRENT_PAGE', response.data);
        return response.data;
      } catch (error) {
        console.error(`Error fetching static page with slug "${slug}":`, error);
        commit('SET_ERROR', error.message || 'Failed to fetch static page');
        throw error; // Rethrow for component handling
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    clearCurrentPage({ commit }) {
      commit('SET_CURRENT_PAGE', null);
    }
  }
}; 